module.exports = __webpack_public_path__ + "media/images/meta/rumble/apple-touch-icon-d18e8cfd8b2d57cfa093963f35bc2cc7.png";